export default {
    name: 'DonationCard',
    props: {
        result: {
            type: Object,
            required: true
        },
        modifierClass:{
            type: String,
            required: false
        }
    },
    setup() {}
}
